<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Point To Ports'"
      :fields="[
      { header: 'Origin Point', prop: (item) => item.originPoint ? item.originPoint.name : '' },
      { header: 'Destination Point', prop: (item) => item.destinationPoint ? item.destinationPoint.name : '' }
      ]"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'PointToPortSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        fields: [
          { header: 'Origin Point', prop: (item) => item.originPoint ? item.originPoint.name : '' },
          { header: 'Destination Point', prop: (item) => item.destinationPoint ? item.destinationPoint.name : '' }
        ],
        loading: false,
        tableData: [],
        entityName: 'point-to-port',
        editEntityScreen: 'Admin - Edit/View Point To Port',
        shouldSearchForExactMatch: true,
        orderBy: 'originPoint'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/PointToPort/PointToPortSearchResults.vue